/* eslint-disable eqeqeq */
import {
    STOP,
    START,
    UPDATE,
} from '../actions/TimerAction'

export const timerReducer = (state = [], action) => {
    switch(action.type){
        case START:
            let newArray = state.slice()
                newArray.splice(newArray.length,1, action.data)
            return newArray
        case STOP:
            let a = state.filter( (item,i) => ( item.id != action.data.id ))
            return a
            case UPDATE:
                let b = state.filter( (item,i) => ( item.id == action.data.id ))[0]
                let c = state.filter( (item,i) => ( item.id != action.data.id ))
                c.splice(c.length,1, b)
            return c
        default:
            return state
    }
}